import Create from './create/CreateEventCost';
import Edit from './edit/EditEventCost';
import Individual from './individual/EventCost';
 
export default { Create, Edit, Individual }; 